import { render, staticRenderFns } from "./home_partners.vue?vue&type=template&id=1a28fac0&scoped=true&"
import script from "./home_partners.vue?vue&type=script&lang=js&"
export * from "./home_partners.vue?vue&type=script&lang=js&"
import style0 from "./home_partners.vue?vue&type=style&index=0&id=1a28fac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28fac0",
  null
  
)

export default component.exports